export enum Status {
  NOT_YET = 'NOT_YET',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
}

export enum Answer {
  YES = 1,
  NO = 0,
}
